module.exports = __webpack_public_path__ + "img/2.1.2e56f000.png";